module.exports = __webpack_public_path__ + "static/lasvegas-0183889686aac3da0940065f2c7dc327.jpg";